<template>
  <div>
    <v-dialog v-model="show" persistent max-width="760" v-if="show">
      <v-card>
        <v-card-title class="headline">Confirmar eliminación</v-card-title>
        <v-card-text>
          <span style="font-size:25px;">
            ¿Está seguro que desea eliminar este elemento? <br />
            Esta opción no se puede deshacer.</span
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="cerrarModalFraccionA()" text>Cancelar</v-btn>
          <v-btn color="red darken-1" @click="confirmarEliminacionFraccionA()" text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "ModalConfirmarEliminacion",
  data: () => ({}),
  methods: {
    cerrarModalFraccionA() {
      this.$emit("cerrarModalFraccion");
    },
    confirmarEliminacionFraccionA() {
      this.$emit("confirmarEliminacionFraccionA");
    }
  },
  props: {
    show: Boolean
  }
};
</script>
